import type { ImportRowError } from '@paintscout/api'

// CSV-formula-injection guard, mirroring `apps/api/src/services/import/error-rows-csv.ts`: a cell
// opening with one of these is read as a formula by Excel/Sheets. A leading `'` forces plain text.
const FORMULA_PREFIX_RE = /^[=+\-@\t\r]/

function escapeCell(value: string): string {
  let cell = FORMULA_PREFIX_RE.test(value) ? `'${value}` : value
  if (/["\n\r,]/.test(cell)) {
    cell = `"${cell.replaceAll('"', '""')}"`
  }
  return cell
}

function toCsvLine(cells: string[]): string {
  return cells.map(escapeCell).join(',')
}

export const JOB_ERRORS_CSV_HEADERS = ['Row', 'Label', 'Errors']

/**
 * The results-screen error report.
 *
 * An `ImportJob` stores `{ row, label, codes, messages }` only — never the source row — so this
 * report identifies each failed row rather than reproducing it. The Review step's
 * `ImportPreview.errorRowsCsv` stays the "fix and re-upload" file (plan U11).
 */
export function buildJobErrorsCsv(errors: ImportRowError[]): string {
  const lines = [toCsvLine(JOB_ERRORS_CSV_HEADERS)]

  for (const error of errors ?? []) {
    lines.push(toCsvLine([String(error.row), error.label ?? '', (error.messages ?? []).join('; ')]))
  }

  return lines.join('\n')
}
